<template>
  <Modal
    v-model:visible="isVisible"
    class="document-request-result-modal"
    :header="t('shipments.documentRequestResult')"
    @keypress.esc="isVisible = false"
  >
    <Section
      id="new-documents-section"
      :header="t('shipments.documentsReceived')"
    >
      <span v-for="(document, i) in newDocuments" :key="`new-document-${i}`">
        {{
          document.documentType
            ? translateEnum(document.documentType, 'CorsairDocumentType')
            : t('shipments.unknownDocumentType')
        }}
        <ul>
          <li
            v-for="(name, j) in document.documentNames"
            :key="`document-name-${i}-${j}`"
          >
            {{ name }}
          </li>
        </ul>
      </span>
      <span v-if="!newDocuments.length">
        {{ t('shipments.noDocumentsReceived') }}
      </span>
    </Section>
    <Section
      v-if="errorResponses.length"
      id="errors-section"
      :header="t('errors.errors', 2)"
    >
      <span v-for="(response, i) in errorResponses" :key="`error-${i}`">
        {{
          response.documentType
            ? translateEnum(response.documentType, 'CorsairDocumentType')
            : t('shipments.unknownDocumentType')
        }}
        <ul>
          <li>
            {{ response.errorMessage }}
          </li>
        </ul>
      </span>
    </Section>
  </Modal>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { translateEnum } from '@rygen/rygen-ui/i18n';

import { DocumentRequestResponse } from '@/model';

import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const props = defineProps({
  responses: {
    type: Array<DocumentRequestResponse>,
    default: [],
  },
});

const { responses } = toRefs(props);

const { t } = useI18n();

const newDocuments = computed(() => {
  return responses.value
    .filter((r) => r.errorMessage == null)
    .filter((r) => r.documentNames?.length);
});

const errorResponses = computed(() => {
  return responses.value.filter((r) => r.errorMessage != null);
});
</script>
